SIZE = 256
LAYER_HEIGHT = 64
DEFAULT_VERTEX_SHADER = ""

layers = null
overlayer = null
selected_layer = null
hammer = null

canvas_container = null
container = null
header_background = null

page = null
current_page_index = 0
current_page = null

bouncer = null
middle = null

clock = 0

toner = new Toner()

p5.disableFriendlyErrors = true

root_style = getComputedStyle(document.body)
for k, v of Colors
  Colors[k] = root_style.getPropertyValue("--#{k}")

screen_orientation = ""

font = null

current_winner = -1
english = false

connect_hammer = (element, host) ->
  hammer = new Hammer.Manager element

  hammer.add new Hammer.Pan(direction: Hammer.DIRECTION_ALL, threshold: 0 )
  hammer.add new Hammer.Tap()
  hammer.add new Hammer.Press()

  hammer.on "pan", host.pan.bind host
  hammer.on "panstart", host.interact.bind host
  hammer.on "panend", host.interact.bind host
  hammer.on "press", host.interact.bind host
  hammer.on "pressup", host.interact.bind host
  hammer.on "tap", host.interact.bind host

set_background = (a, b) ->
  back = document.getElementById("bg_gradient")
  back.style.background = "linear-gradient(180deg, var(--#{a}) 0%, var(--#{b}) 100%)";
  back = document.getElementById("header_background")
  back.style.background = "linear-gradient(180deg, var(--#{b}) 0%, var(--white) 100%)";


init_input = () ->
  # document.addEventListener "wheel", (e) -> overlayer.step_selected(Math.sign(e.deltaY))

preload = () ->
  DEFAULT_VERTEX_SHADER = loadStrings "src/default.vert"
  font = loadFont "assets/font/fixedfixedsys.ttf"
  overlayer = new OverLayer(SIZE)
  overlayer.preload()

  layers =
    topograph : new Topograph SIZE
    flow : new Flow SIZE
    tile: new Tile SIZE
    goal: new Goal SIZE
    spawn: new Spawn SIZE
    clouds : new Clouds SIZE
    game: new Game SIZE

  for k, v of layers
    layers[k].preload()

in_viewport = (element) ->
  r = element.getBoundingClientRect()
  collideRectRect 0,0,innerWidth, innerHeight, r.x, r.y, r.width, r.height

scroll = (e) ->
  if screen_orientation is "landscape"
    sy = window.scrollY

new_element = (type, options) ->
  # console.log options
  d =
    switch type
      when "div" then createDiv()
      when "img" then createImg(options.src)
  for k, v of options
    switch k
      when "css"
        for key, value of v
          d.style key, value
      when "click"
        d.elt.addEventListener "click", v
      else
        if typeof d[k] is "function"
          d[k] v
  d


create_page = (container) ->
  page =
    header : new_element("div"
      class : "header",
      id : "header",
      # css :
      #   background : "#f00"
      parent : container
    )
    container : new_element("div"
      parent : container
    )
    main_container : container
  header_background = new_element("div",
    id : "header_background"
    parent: page.header
  )



build_page = () ->
  container = new_element("div"
    id : "container"
  )
  document.addEventListener "scroll", scroll

  create_page container

build_menu = () ->
  menu = document.getElementById("menu")
  left = new_element("div"
    html : "<"
    id : "left_menu_button"
    class : "menu_button"
    click : (e) ->
      step_page -1, true
  )

  middle = new_element("div"
    html : ""
    id : "middle_menu_button"
    class : "menu_button"
    click : (e) ->
      scroll_top(true)
      overlayer.reset_layer()
  )


  right = new_element("div"
    html : ">"
    id : "right_menu_button"
    class : "menu_button"
    click : (e) ->
      step_page 1, true
  )

  menu.appendChild left.elt
  menu.appendChild middle.elt
  menu.appendChild right.elt

page_from_id = (id) ->
  p = Pages.find (page) -> page.id is id
  if p? then p else page_from_id StartPage

hash_to_state = (hash) ->
  hash = window.location.hash.substring(1)

  if hash isnt ""
    nt = hash.split("/")
    if nt[0] is "nyertesek" or nt[0] is "winners"
      next_lang = nt[0] is "winners"
      next_winner = if nt.length > 1 then url_to_id nt[1] else -1

      page : page_from_id "nyertesek"
      winner : next_winner
      english : next_lang
    else
      page : page_from_id hash
      winner : -1
      english : false
  else
    page : page_from_id StartPage
    winner : -1
    english : false

setup = () ->
  build_menu()
  build_page()
  bouncer = new Bouncer()
  overlayer.init layers, page.header.elt
  overlayer.canvas = document.getElementById("defaultCanvas0")
  page.header.elt.appendChild overlayer.canvas

  connect_hammer overlayer.canvas, overlayer

  open_page hash_to_state()

  init_input()

  window.addEventListener "hashchange", (e) ->
    console.log "hashchange", e.oldURL, "->", e.newURL
    if e.newURL isnt e.oldURL
      open_page hash_to_state()


draw = () ->
  dt = deltaTime * 0.001
  clock = (clock + dt)
  clock -= Math.floor clock
  overlayer.draw(dt, clock)
  bouncer.update(dt)

load_page = (p) ->
  $(page.container.elt).load p.source, () ->
    resize_page()
    if current_page.id is "nyertesek"
      open_winner_page current_winner, english

open_page_by_id = (id) ->
  if (id is "nyertesek" || id is "winner")
    open_page { page : page_from_id id, english : english, winner : 1 } 
  else
    open_page { page : page_from_id id, english : english, winner : -1 } 

open_page = (next) ->
  if not current_page? or current_page.title isnt next.page.title or next.winner isnt current_winner or next.english isnt english
    current_winner = next.winner
    current_page = next.page
    english = next.english
    current_page_index = Pages.findIndex (page) -> page.title is next.page.title

    set_background next.page.colors.a, next.page.colors.b
    middle.html current_page.title

    overlayer.select_layer next.page.layer

    if current_page.id isnt "nyertesek"
      window.location.hash = current_page.id

    load_page next.page

step_page = (d, from_button = false) ->
  if current_winner is -1
    toner.start()
    current_page_index += d
    if current_page_index < 0
      current_page_index = Pages.length - 2
    else
      current_page_index = current_page_index % (Pages.length - 1)

    open_page { page : Pages[current_page_index], english : english, winner : -1 }
  else if from_button
    open_winner_page -1, english

id_to_url = (id) ->
  monogramm = (n) ->
    a = n.split(" ")[0][0]
    if n.split(" ")[0][1] is "y"
      a += "Y"
    b = n.split(" ")[1][0]
    a + b
  _Nyertesek[id].name.map(monogramm).join("").replace("Á", "A")

url_to_id = (url) ->
  for n, i in _Nyertesek
    if id_to_url(i) is url
      return i
  return -1

get_winner_url = (id) ->
  nt = 
    if id is -1
      ""
    else
      "/" + id_to_url(id)

  l = if english then "winners" else "nyertesek"
  document.location.pathname + "##{l}" + nt

set_winner_url = (id) ->    
  url = get_winner_url(id)
  history.replaceState null, null, url

winner_list = (eng) ->
  _Nyertesek.map((w, i) =>
    $("<h3>", html : $("<a>", html : w.name.join(" "), href : get_winner_url(i)), class : "winner-name", css: {"text-align" : "center"})
  ).concat ["<br><br>"]

request_fullscreen = (video) ->
  if video?
    if not document.fullscreenElement?
      video.requestFullscreen()
      # $(video).focus()
    else
      if document.fullscreen
        if document.exitFullscreen? then document.exitFullscreen()
        else if document.webkitExitFullscreen? then document.webkitExitFullscreen()
        else if document.msExitFullscreen? then document.msExitFullscreen()

winner_page = (w, i) ->
  $("<div>", 
    class : "winner-block",
    id : id_to_url i
    html : [
      $("<h1>", class : "winner-title", html : w.title)
      $("<h2>", class : "winner-name", html : w.name)
      $("<video>", id : "winner-video_#{i}", class : "winner-video", 
      ).attr
        crossorigin : "anonymous"
        controls : "controls"
        preload : "auto"
        src : w.video_link
      .show()
      .on "play", (e) => solo_video parseInt(e.currentTarget.id.split("_")[1])
      .on "keydown", (e) =>
        switch e.originalEvent.code
          when "Space"
            e.preventDefault()
      $("<p>", html : w.text)
    ]
  )

open_winner_page = (index, eng) ->
  console.log "winner_page", index, eng
  if index == undefined
    index = -1;

  if eng
    $("#verseny-title").hide()
  else
    $("#verseny-title-english").hide()

  current_winner = index

  set_winner_url current_winner

  ws = 
    if eng
      _Winners.map((w, i) -> 
        w.video_link = _Nyertesek[i].video_link
        w
      )
    else 
      _Nyertesek

  $("#winner-list").html winner_list(eng)

  winner_pages = []
  for w, i in ws
    wp = winner_page w, i
    winner_pages.push wp
    $("#winner-list").append wp

  jump_to winner_offset(current_winner), () -> document.addEventListener("scroll", scroll_winner_page)

winner_offset = (id) ->
  if id is -1 
    # 0
    if screen_orientation is "landscape" then 0 else innerWidth
  else
    $("#" + id_to_url(id)).get(0).offsetTop - 40

jump_to = (offset, callback) ->
  console.log "jumping to winner", offset
  $("html").animate({scrollTop : offset}, 500, "linear", callback)

step_winner = (d) ->
  current_winner = constrain(current_winner + d, -1, _Nyertesek.length - 1)
  set_winner_url current_winner
  jump_to winner_offset current_winner

get_winner_top = (i) ->
  if i is -1 
    return 0
  else
    $("#" + id_to_url(i))[0].offsetTop

scroll_winner_page = (e) ->
  if current_page.id isnt "nyertesek" then return false
  prev_id = constrain(current_winner - 1, -1, _Nyertesek.length - 1)
  next_id = constrain(current_winner + 1, 0, _Nyertesek.length - 1)

  current = get_winner_top current_winner
  next = get_winner_top next_id
  prev = get_winner_top prev_id

  nt = current_winner
  # dead_zone = 100
  dead_zone = innerHeight * (2/5)
  scroll_top_pos = $("html").scrollTop() + dead_zone
  scroll = scroll_top_pos / $("html").outerHeight()
  if scroll_top_pos < current
    nt = prev_id
  else if scroll_top_pos > next
    nt = next_id

  if current_winner isnt nt
    current_winner = nt
    set_winner_url nt
    solo_video nt

current_video = () ->
  if current_winner isnt -1
    $("#container").find(".winner-video")[current_winner]
  else
    console.log "no video for #{current_winner}"
    null

toggle_video = (t) ->
  v = $("#container").find(".winner-video")[t]
  if v.paused
    v.play()
  else
    v.pause()

  solo_video t

solo_video = (t) ->
  vs = $("#container").find(".winner-video")
  for v, i in vs
    if i isnt t
      v.pause()
  if t isnt -1
    vs[t].focus(preventScroll : true)

windowResized = () ->
  resize_page()

mouseMoved = () ->
  x = mouseX
  y = mouseY

rem_pixel = (rem) ->
  rpx = rem * parseFloat(getComputedStyle(document.documentElement).fontSize)
  # console.log rpx
  rpx

scroll_top = (forced_y) ->
  if screen_orientation is "landscape"
    window.scrollTo({
      top : 0
      left : 0
      behavior : 'smooth'
    })
    # window.scrollTo 0 0
  else
    setTimeout(
      (() ->
        window.scrollTo(
          top:
            if forced_y or window.scrollY >= innerWidth / 3.0
              innerWidth / 1.5
            else
              0
          left: 0
          behavior: 'smooth'
        ))
      1000
    )

resize_page = () ->
  ratio = innerWidth / innerHeight
  c = document.getElementById "defaultCanvas0"


  new_orientation = if ratio > 1.3 then "landscape" else "portrait"

  if new_orientation isnt screen_orientation
    screen_orientation = new_orientation
    if screen_orientation is "landscape"
      page.header.class "floater"
      container.class ""
    else
      page.header.class "header"
      container.class "mobile-container"

  if current_page.id isnt "nyertesek"
    scroll_top()

  if screen_orientation is "landscape"
    w = container.size().width
    ws = innerWidth - w
    floater_h = innerHeight * 0.7
    margin = "0"
    free_space = innerWidth - (w + innerHeight)

    if free_space > 0
      margin = (free_space * 0.5) + "px"
    else
      floater_h = ws * 0.7

    page.header.style "width", "#{floater_h}px"
    page.header.style "height", "#{floater_h}px"
    page.container.style "padding-left", ""
    page.container.style "padding-right", ""
    page.container.style "width", ""
    container.style "margin-left", "#{margin}"
    bouncer.show true
    header_background.hide()

  else # portrait mode
    full_row = rem_pixel(40)
    if full_row + rem_pixel(3) < innerWidth
      pad = ((innerWidth - full_row) / 2) + "px"
      page.container.style "padding-left", pad
      page.container.style "padding-right", pad
      # page.container.style "width", "#{full_row}px"
    else
      pad = (((innerWidth - full_row) * 0.5)) * 0.5 + "px"
      page.container.style "padding-left", "1rem"
      page.container.style "padding-right", "1rem"
      page.container.style "width", ""


    page.header.style "top", ""
    page.header.style "width", ""
    page.header.style "height", ""
    bouncer.show false
    container.style "margin-left", ""
    header_background.show()

keyPressed = (e) ->
  target = e.target || e.srcElement
  if (!/INPUT|TEXTAREA|SELECT|BUTTON/.test(target.nodeName))
    if current_page.id is "nyertesek"
      switch e.key
        when "ArrowDown"
          if not document.fullscreen
            step_winner 1
        when "ArrowUp"
          if not document.fullscreen
            step_winner -1
        when "f"
          request_fullscreen current_video()

        when " "
          if current_winner isnt -1
            console.log current_winner
            toggle_video current_winner

    switch e.key
      # when "d"
      #   debug = not debug
      #   localStorage.setItem "debug", debug
      when "ArrowLeft"
        step_page -1
      when "ArrowRight"
        step_page 1


class Bouncer
  speed : 100
  dir :
    x : 1
    y : 1
  last_pos :
    x : 0
    y : 0
  last_scroll : 0
  logo_index : 0
  constructor: () ->
    @frame = 0
    @element_x = document.getElementById("bouncer")
    @element_x.addEventListener "click", @step_logo.bind @
    @element_y = @element_x.children[0]
    @logo = @element_y.children[0]

    @set_logo Math.floor(Math.random() * Logos.length)
    document.body.appendChild @element_x
  get_pos : () ->
    tx = window.getComputedStyle(@element_x).getPropertyValue("transform")
    tx = tx.split(",")
    ty = window.getComputedStyle(@element_y).getPropertyValue("transform")
    ty = ty.split(",")
    createVector parseFloat(tx[4]), parseFloat(ty[5])
  step_logo : () ->
    @set_logo (@logo_index + 1) % Logos.length

  set_logo : (i) ->
    @logo_index = i
    l = Logos[@logo_index]
    @logo.style.top = "#{50 + 100 * l.y}%"
    @logo.style.width = "#{l.scale * 180}px"
    @logo.src = l.source()

    # root_style.setPropertyValue("--x-speed", "19s")
    # window.getComputedStyle(document.body).style.setPropertyValue("--x-speed", "19s")
  show : (visible) ->
    @element_x.style.display = (if visible then "block" else "none")

  update : (delta) ->
    p = @get_pos()

    dx = if p.x < @last_pos.x then -1 else 1
    dy = if p.y < @last_pos.y then -1 else 1

    if @dir.x isnt dx or @dir.y isnt  dy
      @dir.x = dx
      @dir.y = dy
      @step_logo()



    @last_pos = p
    @frame += 1
    if @frame > 60
      @frame = 0
      sy = window.scrollY
      if sy isnt @last_scroll
        @last_scroll = sy
        @element_x.style.top = @last_scroll + "px"
        # console.log @element_x.style.top

###
TODO
- play button
- sound effects
- juice
  - goal
  - spawn restrict
  - tile
  - autopilot

minify with

uglifyjs src/config.js src/layer.js src/shader_layer.js src/goal.js src/spawn.js src/tile.js src/clouds.js src/topograph.js src/flow.js src/particle.js src/game.js src/overlayer.js src/main.js -o src/script.min.js

###
